//LL: 12.07.23 Calendar (copy Grid)

import * as React from 'react';
import * as _ from 'underscore'; //LL: 16.07.23: try after OE's great changes in GIT
import * as $ from 'jquery';

import { IGlob } from '../../../../_common/application/ts/Glob';

import AttrQueryField from '../../../../pdc-widget-calendar/src/ts/components/AttrQueryField';
import AttrQueryFilterField from '../../../../_common/platform/tsx/filtering/AttrQueryFilterField';
import DataSourceSelectorContainer from '../../../../_common/platform/tsx/DataSourceSelectorContainer';
import { IntegerNumberField } from '../../../../_common/platform/tsx/IntegerNumberField';
import BooleanField from '../../../../_common/platform/tsx/BooleanField';

import { validators as Validators } from '../../../../_common/platform/ts/validators';
import * as GridValidators from './Validators';
import { validators as AppValidators } from '../../../../_common/application/ts/validators';
import * as Utilities from '../../../../_common/platform/ts/Utilities';

import { IDatasource, DataloadEventTypes } from '../../../../pdc-platform/src/ts/stores/EntityModelsStore';

import { IAttrQueryFilterFieldValue } from '../../../../_common/platform/tsx/filtering/Interfaces';

import { IDataQuery, IAttrQuery } from '../../../../pdc-widget-calendar/src/ts/components/Interfaces';

import { IValuesCollection } from '../../../../_common/platform/ts/appTheme';
import ParameterFieldBase, { IParameterFieldBaseOptions } from '../../../../_common/platform/ts/ParameterFieldBase';
import * as FilterUtilities from '../../../../_common/platform/tsx/filtering/FilterUtilities';
import { ParameterField } from '../../../../_common/platform/tsx/ParameterField';

interface IAttributesFieldState {
    value: IDataQuery;
    applyEnabled?: boolean; //LL: showApplyButton - to use in Option Tab (in CalendarMarkersField)
}

export interface IAttributesFieldOptions extends IParameterFieldBaseOptions {
    useClickToFilter?: boolean;
    inHtmlContainer?: boolean;
    DisplayValuesList?: any; //LL: Calendar
    hiddenFields?: any; //LL: Calendar
    showApplyButton?: boolean; //LL: Calendar
}

interface IAttributesFieldProps {
    value?: IDataQuery;
    theme: IValuesCollection;
    tabID?: number;
    values?: any[];
    options?: IAttributesFieldOptions;
    param?: any; //LL: Calendar
    glob: IGlob;

    themeObj?: any; //LL: 25.06.24: for Markers DataSource:

    onChange?(value: IDataQuery): void;
    onApply?(value: IDataQuery): void; //LL: Calendar
}

export default class AttributesField extends React.Component<IAttributesFieldProps, IAttributesFieldState> {
    constructor(props) {
        super(props);

        this.state = this.getState(this.props);

        //LL: showApplyButton - to use in Option Tab (in CalendarMarkersField)
        this.setState({ applyEnabled: false });
    }

    getState(props: IAttributesFieldProps): IAttributesFieldState {
        let value = props.value;

        if (value == null) {
            value = {
                dataSourceID: null,
                attrQuery: [],
                attrQueryFilter: [],
                endlessScrolling: false
            };
        }

        if (value.limit == null) {
            value.limit = 50;
        }

        if (props.options != null && props.options.inHtmlContainer === true) {
            value.endlessScrolling = false;
        }

        if (value.dataSourceID == null) {
            value.dataSourceID = props.glob.EntityModelsStore.getStoredDataSourceID();
        }

        return {
            value: value
        };
    }

    componentDidMount() {
        this.props.glob.EntityModelsActions.loadDataSources();
        this.props.glob.EntityModelsStore.addOnDataLoadListener(this.handleOnEntityModelsChange);
    }

    componentWillUnmount() {
        this.props.glob.EntityModelsStore.removeOnDataLoadListener(this.handleOnEntityModelsChange);
    }

    componentWillReceiveProps(nextProps: IAttributesFieldProps) {
        this.setState(this.getState(nextProps));
    }

    handleOnEntityModelsChange = (eventType: DataloadEventTypes) => {
        if (eventType === DataloadEventTypes.DATASOURCES) {
            this.setState(this.state);
        }
    };

    getValueCopy() {
        return $.extend(true, {}, this.state.value);
    }

    getDataSources(): IDatasource[] {
        return this.props.glob.EntityModelsStore.getDataSources();
    }

    // https://masteringjs.io/tutorials/fundamentals/wait-1-second-then
    delay(time) {
        return new Promise((resolve) => setTimeout(resolve, time));
    }

    //LL: Calendar: add applyEnabledState
    processValueChange(value: IDataQuery, applyEnabledState = true) {
        //this.setState({ value: value });
        //LL: Calendar: showApplyButton - to use in Option Tab (in CalendarMarkersField)

        let toApplyExist = value.toApply != null;

        let v = $.extend(true, {}, value);
        delete v.toApply;
        this.setState({ value: v, applyEnabled: applyEnabledState });

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
            //LL: and again to unset "toApply" in saved value
            if (toApplyExist) {
                //this.props.onChange(v);
                //delay(1000).then(() => console.log('ran after 1 second1 passed'));
                //this.delay(1000).then(() => this.props.onChange(v)); //LL: OK
                // or
                setTimeout(() => {
                    this.props.onChange(v);
                }, 1000);
            }
        }
    }

    handleOnDataSourceChange = (id, dataSourceID: number) => {
        const stateValue = this.getValueCopy();

        stateValue.dataSourceID = dataSourceID;
        this.props.glob.EntityModelsStore.storeDataSourceID(dataSourceID);

        stateValue.attrQuery = [];
        stateValue.attrQueryFilter = [];

        this.processValueChange(stateValue);
    };

    handleOnQueryRootEntityChange = (value: string) => {
        const stateValue = this.getValueCopy();

        if (value != null) {
            stateValue.queryRootEntity = value;
        } else {
            delete stateValue.queryRootEntity;
        }

        this.processValueChange(stateValue);
    };

    handleAttrQueryFieldChange = (value: IAttrQuery[]) => {
        const stateValue = this.getValueCopy();

        stateValue.attrQuery = [...value];

        this.processValueChange(stateValue);
    };

    handleAttrQueryFilterFieldChange = (value: IAttrQueryFilterFieldValue) => {
        const stateValue = this.getValueCopy();

        stateValue.attrQueryFilter = value.filters;
        stateValue.globalFilterControl = value.globalFilterControl;

        this.processValueChange(stateValue);
    };

    handleOnDataLimitChange = (value: number) => {
        const stateValue = this.getValueCopy();

        stateValue.limit = value;

        this.processValueChange(stateValue);
    };

    handleEndlessScrollingChange = (value: boolean) => {
        const stateValue = this.getValueCopy();

        if (value) {
            this.props.glob.AppActions.showNotification_Warning(
                'When Endless Scrolling is on in-place filtering, column summary, sorting and grouping will not work.'
            );
        }

        stateValue.endlessScrolling = value;
        this.processValueChange(stateValue);
    };

    handleOnDistinctChange = (value: boolean) => {
        const stateValue = this.getValueCopy();
        stateValue.distinct = value;
        this.processValueChange(stateValue);
    };

    private getTheme() {
        //LL: 25.06.24: for Markers DataSource:
        if (this.props.themeObj != null) {
            return this.props.themeObj;
        }
        if (this.props.options != null && this.props.options.theme != null) {
            return this.props.options.theme;
        } else if (this.props.theme != null) {
            return this.props.theme;
        }

        return undefined;
    }

    getTabID() {
        return this.props.tabID || this.props.options?.tabID;
    }

    //LL: Calendar: showApplyButton - to use in Option Tab (in CalendarMarkersField)
    applyButtonHandler = () => {
        this.setState({ applyEnabled: false });

        const stateValue = this.getValueCopy();
        if (typeof this.props.onApply === 'function') {
            this.props.onApply(stateValue);
        } else {
            stateValue.toApply = true;
            this.processValueChange(stateValue, false);
        }
    };

    render() {
        const value = this.state.value;
        const dataSources = this.getDataSources();
        const dataSourceID = value.dataSourceID;
        const validEntities = this.props.glob.EntityModelsStore.getValidEntitiesForMultipeRootFunctionality(
            value.attrQuery,
            value.attrQueryFilter
        );
        const endlessScrolling = value.endlessScrolling === true;
        const theme = this.getTheme();
        const tabID = this.getTabID();

        let useClickToFilter = false;

        if (value != null) {
            useClickToFilter = FilterUtilities.useClickToFilterFunctionality(theme);
        }

        //See WI 101342. ID is needed to make visual reoredring work.
        Utilities.addIDToItems(value.attrQuery);

        const dataLimitTitle = endlessScrolling ? 'Number of Records per Fetch' : 'Data Limit';

        //LL: Calendar  commented:
        let endlessScrollingComponent: React.JSX.Element;
        if (this.props.options == null || this.props.options.inHtmlContainer !== true) {
            //endlessScrollingComponent = (
            //    <div className="field no-title">
            //        <ParameterField
            //            noTitle={ true }
            //            clearable={ false }
            //        >
            //            <BooleanField
            //                title={ 'Endless Scrolling' }
            //                value={ endlessScrolling }
            //                allowNull={ false }
            //                onChange={ this.handleEndlessScrollingChange }
            //            />
            //        </ParameterField>
            //    </div>
            //);
        }

        //LL: DisplayValuesList - new Calendar
        //LL: hiddenFields?: any;   Calendar

        //LL: Calendar: showApplyButton - to use in Option Tab (in CalendarMarkersField) applyButtonHandler
        let applyButton;
        let applyNote; //LL: 09.11.23
        if (this.props.options.showApplyButton === true) {
            let applyButtonDisabled = false;
            if (this.state != null && this.state.applyEnabled != null) {
                applyButtonDisabled = !this.state.applyEnabled;
            }
            if (this.props.param != null && this.props.param.errors != null) {
                applyButtonDisabled = this.props.param.errors.length > 0;
            }

            applyButton = (
                <button className="btn btn-success" onClick={this.applyButtonHandler} disabled={applyButtonDisabled}>
                    Apply
                </button>
            );

            //LL: 09.11.23
            let pStyle: any = {
                //border:'1px dotted #808080', paddingLeft:'3px', //LL: 10.11.23: commented, no when className="explanation"
                marginTop: '2px',
                marginBottom: '2px',
                paddingTop: '4px',
                paddingBottom: '4px',
                //maxWidth: 'none !important'
                maxWidth: 'none'
            };
            //LL: 10.11.23: className="explanation"
            applyNote = (
                <div style={{ margin: '8px 0' }}>
                    <p style={pStyle} className="explanation">
                        {'Use '}
                        <span style={{ fontWeight: 'bolder' }}>{'"Apply" button '}</span>
                        {'to execute data query and apply its result to '}
                        <span style={{ fontWeight: 'bolder' }}>{'"Period Types" '}</span>
                        {'below.'}
                    </p>
                    <p style={pStyle} className="explanation">
                        <span style={{ fontWeight: 'bolder' }}>{'Advice on using the Filter: '}</span>
                        {'most probably you need to set '}
                        <span style={{ fontWeight: 'bolder' }}>{'"Ignore All Global Filtering" '}</span>
                        {'in Filter configuration.'}
                    </p>
                </div>
            );
        }

        //LL: 09.11.23: applyNote
        return (
            <div className="attributes-field">
                {applyNote}
                <div>
                    <div className="field">
                        <ParameterField noTitle={true} clearable={false}>
                            <IntegerNumberField
                                title={dataLimitTitle}
                                value={value.limit}
                                validators={[Validators.number.not_negative, Validators.number.integer]}
                                glob={this.props.glob}
                                onChange={this.handleOnDataLimitChange}
                            />
                        </ParameterField>
                    </div>

                    {endlessScrollingComponent}

                    <div className="field no-title">
                        <ParameterField noTitle={true} clearable={false}>
                            <BooleanField
                                title={'Distinct'}
                                value={value.distinct}
                                allowNull={false}
                                onChange={this.handleOnDistinctChange}
                            />
                        </ParameterField>
                    </div>
                </div>

                <DataSourceSelectorContainer
                    datasources={dataSources}
                    selectedDataSourceID={dataSourceID}
                    canBeRemoved={false}
                    showQueryRootEntityField={true}
                    queryRootEntity={value.queryRootEntity}
                    glob={this.props.glob}
                    onDataSourceChange={this.handleOnDataSourceChange}
                    onQueryRootEntityChange={this.handleOnQueryRootEntityChange}
                >
                    <AttrQueryField
                        value={value.attrQuery}
                        dataSourceID={dataSourceID}
                        endlessScrolling={endlessScrolling}
                        disableClickToFilter={!useClickToFilter}
                        validEntities={validEntities}
                        theme={theme}
                        tabID={tabID}
                        glob={this.props.glob}
                        onChange={this.handleAttrQueryFieldChange}
                        DisplayValuesList={this.props.options.DisplayValuesList}
                        hiddenFields={this.props.options.hiddenFields}
                    />

                    <AttrQueryFilterField
                        value={{
                            filters: value.attrQueryFilter,
                            globalFilterControl: value.globalFilterControl
                        }}
                        dataSourceID={dataSourceID}
                        validEntities={validEntities}
                        theme={theme}
                        tabID={tabID}
                        glob={this.props.glob}
                        onChange={this.handleAttrQueryFilterFieldChange}
                    />
                </DataSourceSelectorContainer>

                {applyButton}
            </div>
        );
    }
}

export class AttributesParameterField extends ParameterFieldBase<IAttributesFieldOptions> {
    public static defaultValidators = [
        GridValidators.validateGroupingAttributes,
        //GridValidators.validateDataLimit,
        //GridValidators.validateRoles, //LL: Calendar  Not interesting
        //LL: 30.08.23: in main:   GridValidators.validateRolesPar('HHH'), //LL: new Calendars
        AppValidators.attributesParameterField.validateLocalFilter
    ];

    public static EditComponent = AttributesField;

    public static getDefaultValue() {
        return {
            dataSourceID: null, //Is set to null in order to make Storing Datasource ID work.

            attrQuery: [],
            attrQueryFilter: [],
            endlessScrolling: false //LL: Calendar
        };
    }

    public getDefaultOptions() {
        return {
            fix: (value, validators, widgetData) => {
                return GridValidators.fix(value, widgetData, this.glob);
            }
        };
    }

    constructor(glob: IGlob, title: string, validators?: any, defaultVal?: any, options?: IAttributesFieldOptions) {
        if (defaultVal == null) {
            defaultVal = AttributesParameterField.getDefaultValue();
        }

        super(glob, title, AttributesParameterField.defaultValidators, validators, defaultVal, options);
    }
}

